<template>
  <div
    id="alvexoPlusForm"
    class="form_desktop_wrap"
    :class="currentPage"
    v-show="userStatusReturned"
  >
    <!-- form -->
    <div
      class="form_wrap"
      v-if="!this.isLoggedIn"
      :class="{
        'secondary-form':
          this.displayedAuthForm == 'registration' &&
          this.registrationStep == 2,
        'login-form': this.displayedAuthForm == 'login',
        'login-err': this.loginForm.formError,
        'regFront-err': this.regFormPartOne.formError,
        'regBack-err': this.regFormPartTwo.formError
      }"
    >
      <h2 class="title">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="219.655"
          height="62.166"
          viewBox="0 0 219.655 62.166"
        >
          <defs></defs>
          <g transform="translate(-124 -631)">
            <g transform="translate(-258.973 537.321)">
              <path
                class="a"
                d="M407.955,143.337q-3.559,5.221-10.621,5.223a13.449,13.449,0,0,1-10.445-4.451,17.017,17.017,0,0,1,0-21.72,13.794,13.794,0,0,1,10.741-4.451,11.774,11.774,0,0,1,10.325,5.283v-4.807h4.451v29.671h-4.451Zm-10.029,1.186a9.4,9.4,0,0,0,7.6-3.322,13.177,13.177,0,0,0,0-15.9,9.4,9.4,0,0,0-7.6-3.322,9.851,9.851,0,0,0-7.713,3.322,12.727,12.727,0,0,0,0,15.9A9.851,9.851,0,0,0,397.926,144.523Z"
              />
              <path class="b" d="M425.692,148.15h-6.225V107.342h6.225Z" />
              <path
                class="a"
                d="M460.538,118.414l-11.571,29.671h-5.222l-11.632-29.671h4.867l9.375,24.923,9.317-24.923Z"
              />
              <path
                class="a"
                d="M477.57,144.523q5.992,0,8.6-4.984h4.866a14.321,14.321,0,0,1-4.9,6.527,14.1,14.1,0,0,1-8.635,2.494,14.356,14.356,0,0,1-10.919-4.451,15.188,15.188,0,0,1-4.094-10.86,15.45,15.45,0,0,1,3.917-10.86,15.328,15.328,0,0,1,21.6,0,15.45,15.45,0,0,1,3.916,10.86v1.78H467.066a10.763,10.763,0,0,0,3.264,6.765A10.041,10.041,0,0,0,477.57,144.523Zm-.355-22.548a9.826,9.826,0,0,0-6.885,2.55,10.547,10.547,0,0,0-3.2,6.352H487.3a10.551,10.551,0,0,0-3.2-6.352A9.829,9.829,0,0,0,477.215,121.975Z"
              />
              <path
                class="a"
                d="M509.376,132.774l11.512,15.311h-5.7l-8.366-12.106L498.4,148.085H492.76l11.454-15.311-10.742-14.36h5.7l7.655,11.215,7.6-11.215h5.7Z"
              />
              <path
                class="a"
                d="M536.554,117.938a14.1,14.1,0,0,1,10.8,4.451,17.02,17.02,0,0,1,0,21.72,15.331,15.331,0,0,1-21.6,0,17.02,17.02,0,0,1,0-21.72A14.1,14.1,0,0,1,536.554,117.938Zm0,26.585a9.39,9.39,0,0,0,7.595-3.322,13.169,13.169,0,0,0,0-15.9,10.344,10.344,0,0,0-15.191,0,13.181,13.181,0,0,0,0,15.9A9.392,9.392,0,0,0,536.554,144.523Z"
              />
              <line
                class="b"
                y1="62.166"
                transform="translate(422.58 93.679)"
              />
              <rect
                class="b"
                width="1.147"
                height="62.166"
                transform="translate(422.006 93.679)"
              />
            </g>
            <g transform="translate(-181.955 12.589)">
              <path
                class="a"
                d="M524.793,654.924l-11.106-11.107a3.916,3.916,0,0,0-5.537,0l-11.107,11.107a3.916,3.916,0,0,0,0,5.537l11.107,11.106a3.914,3.914,0,0,0,5.537,0l11.106-11.106A3.914,3.914,0,0,0,524.793,654.924Zm-5.784,4.9h-6.3l-1.043,6.312h-4.284l1.044-6.312h-6.317l.716-4.272h6.307l1.043-6.312h4.284l-1.044,6.312h6.306Z"
                transform="translate(-0.33)"
              />
              <path
                class="c"
                d="M492.624,660.46a3.915,3.915,0,0,1,0-5.537l11.107-11.107a3.966,3.966,0,0,1,.658-.527,3.915,3.915,0,0,0-4.879.527L488.4,654.924a3.914,3.914,0,0,0,0,5.537l11.106,11.106a3.915,3.915,0,0,0,4.879.528,3.929,3.929,0,0,1-.658-.528Z"
                transform="translate(-0.118 0)"
              />
              <path
                class="a"
                d="M484.657,660.46a3.914,3.914,0,0,1,0-5.537l11.106-11.107a3.967,3.967,0,0,1,.658-.527,3.914,3.914,0,0,0-4.878.527l-11.107,11.107a3.916,3.916,0,0,0,0,5.537l11.107,11.106a3.913,3.913,0,0,0,4.878.528,3.93,3.93,0,0,1-.658-.528Z"
                transform="translate(0 0)"
              />
            </g>
          </g>
        </svg>
      </h2>
      <h4 class="sub-title" v-show="isRegStepOne" v-html="t(subTitle)"></h4>
      <!-- START FORM FLIP -->
      <div class="card-container" :class="{ regStepOne: isRegStepOne }">
        <div class="flipcard h" :class="{ flip: this.registrationStep == 2 }">
          <div
            class="front"
            v-show="
              this.displayedAuthForm == 'registration' &&
                this.registrationStep == 1
            "
          >
            <!-- sign-up form -->
            <form
              id="sign_up_form"
              v-on:submit.prevent="submitStep1"
              data-from-ignore-me
            >
              <div
                :class="[
                  'server_error_msg',
                  { active: this.regFormPartOne.formError }
                ]"
              >
                <div class="err_sign"></div>
                <p
                  v-html="this.regFormPartOne.errorMessage"
                  ref="loginErrContainer"
                ></p>
              </div>
              <!-- FirstName -->
              <div
                class="input-wrapper"
                :class="[{ invalid: flaggedFields.name }, inputNameStatus]"
              >
                <div class="form-group">
                  <div class="input_wrap">
                    <input
                      type="text"
                      name="FirstName"
                      :placeholder="t('Form_Name')"
                      maxlength="50"
                      v-model="regFormPartOne.name"
                      v-on:focus="
                        focusedElem('name');
                        scrollOnInputClick($event);
                      "
                      v-on:blur="blurredElem('name')"
                    />
                    <label
                      class="floating_labels"
                      :class="{ active: regFormPartOne.name != '' }"
                      >{{ t("Form_Name") }}</label
                    >
                  </div>
                  <div class="errMsg">{{ t("Please_insert_full_name") }}</div>
                </div>
              </div>
              <!-- Email -->
              <div
                class="input-wrapper"
                :class="[{ invalid: flaggedFields.email }, inputEmailStatus]"
              >
                <div class="form-group">
                  <div class="input_wrap">
                    <input
                      type="email"
                      name="Email"
                      :placeholder="t('Form_Email')"
                      maxlength="100"
                      v-model="regFormPartOne.email"
                      v-on:focus="
                        focusedElem('email');
                        scrollOnInputClick($event);
                      "
                      v-on:blur="blurredElem('email')"
                    />
                    <label
                      class="floating_labels"
                      :class="{ active: regFormPartOne.email != '' }"
                      >{{ t("Form_Email") }}</label
                    >
                  </div>
                  <div class="errMsg">{{ t("Please_insert_valid_email") }}</div>
                </div>
              </div>
              <!-- password -->
              <div
                class="input-wrapper password"
                :class="[
                  { invalid: flaggedFields.password },
                  inputPasswordStatus
                ]"
              >
                <div class="form-group">
                  <div
                    class="input_wrap"
                    :class="{ 'hide-icon': regFormPartOne.password.length > 0 }"
                  >
                    <input
                      :type="[
                        regFormPartOne.visiblePassword ? 'text' : 'password'
                      ]"
                      name="Password"
                      :placeholder="t('Forms_Password')"
                      maxlength="15"
                      v-model="regFormPartOne.password"
                      v-on:focus="
                        focusedElem('password');
                        scrollOnPasswordClick($event);
                      "
                      v-on:blur="blurredElem('password')"
                    />
                    <label
                      class="floating_labels"
                      :class="{ active: regFormPartOne.password != '' }"
                      >{{ t("Forms_Password") }}</label
                    >
                    <span
                      class="eye"
                      :class="{
                        active: regFormPartOne.visiblePassword,
                        showEye: regFormPartOne.password.length > 0
                      }"
                      v-on:click="this.togglePasswordVisibilityReg"
                    ></span>
                  </div>
                  <div id="passwordPopup" v-show="showPasswordRequirements">
                    <h3>{{ t("Registration_Pages_Password_Must_Be") }}</h3>
                    <p id="length" :class="{ valid: this.validPasswordLen }">
                      {{ t("Registration_Pages_Be_a_Minimum_Of") }}
                    </p>
                    <p
                      id="letter"
                      :class="{ valid: this.validPasswordSLetter }"
                    >
                      {{
                        t("Registration_Pages_Include_At_Least_One_Lowercase")
                      }}
                    </p>
                    <p
                      id="capital"
                      :class="{ valid: this.validPasswordCLetter }"
                    >
                      {{
                        t("Registration_Pages_Include_At_Least_One_Uppercase")
                      }}
                    </p>
                    <p id="number" :class="{ valid: this.validPasswordNumber }">
                      {{ t("Registration_Pages_Include_At_Least_One_Number") }}
                    </p>
                    <p
                      id="hasNoSpecialCharacters"
                      :class="{ valid: this.validPasswordNoSpecial }"
                    >
                      {{ t("Registration_Pages_Dont_Use_Special") }}
                    </p>
                    <p
                      id="onlyEnglishCharacters"
                      :class="{ valid: this.validPasswordOnlyEnglish }"
                    >
                      {{ t("Registration_Pages_Use_Only_English_Characters") }}
                    </p>
                  </div>
                  <div class="errMsg">
                    {{ t("Please_insert_valid_password") }}
                  </div>
                </div>
              </div>
              <div class="checkboxWrap">
                <div class="input-wrapper" :class="termsValidationClass">
                  <input
                    type="checkbox"
                    name="Checkbox"
                    v-model="regFormPartOne.terms"
                  />
                  <label></label>
                </div>
                <!--                <p class="checkbox_txt">I hereby agree to the <a-->
                <!--                    href="https://www.alvexo.com/documents/vpr/footer/en_vpr_safe_financial_group_privacy_policy_2020.pdf"-->
                <!--                    target="_blank">privacy policy</a> and to be contacted and receive-->
                <!--                  Alvexo marketing emails , SMS or phone calls.</p>-->
                <p class="checkbox_txt" v-html="t('Checkbox_text')"></p>
              </div>
              <div class="btnWrap">
                <button class="btn semiBold" type="submit">
                  {{ t("Continue_label") }}
                </button>
                <!--                <p class="risk">69.8% of retail CFD accounts lose money</p>-->
              </div>
              <div class="social_signIn">
                <div class="titleWrapper">
                  <span class="decoration"></span>
                  <span>{{ t("Create_account_with") }}</span>
                  <span class="decoration"></span>
                </div>
                <div class="linkWrap">
                  <a class="fb" @click="signUpWithThirdParty('facebook')"></a>
                  <a class="google" @click="signUpWithThirdParty('google')"></a>
                  <a class="apple" @click="signUpWithThirdParty('apple')"></a>
                </div>
              </div>
              <div class="existing-account">
                <span>{{ t("Already_have_account") }} </span>
                <span v-on:click="this.switchToLoginView" class="login-text">{{
                  t("Header_Nav_Log_In")
                }}</span>
              </div>
            </form>
            <!-- /sign_up form -->
          </div>
          <div
            class="back"
            v-show="
              this.displayedAuthForm == 'registration' &&
                this.registrationStep == 2
            "
          >
            <!-- phone form -->
            <form
              id="phone_form"
              v-on:submit.prevent="submitStep2"
              data-from-ignore-me
            >
              <div
                :class="[
                  'server_error_msg',
                  { active: this.regFormPartTwo.formError }
                ]"
              >
                <div class="err_sign"></div>
                <p v-html="this.regFormPartTwo.errorMessage"></p>
              </div>

              <!-- account type -->
              <div class="input-wrapper accountType">
                <div class="form-group">
                  <div
                    class="input_wrap"
                    :class="{ open: accountTypeDropdownOpen }"
                  >
                    <span
                      class="input-wrapper"
                      v-on:click="
                        accountTypeDropdownOpen = !accountTypeDropdownOpen
                      "
                    >
                      <input
                        type="text"
                        name="user_id"
                        maxlength="50"
                        :value="accountType"
                        disabled
                      />
                      <span class="select2-selection__arrow" role="presentation"
                        ><b role="presentation"></b
                      ></span>
                    </span>
                    <label
                      v-show="this.registrationStep == 2"
                      class="floating_labels active"
                      >{{ t("Account_type_label") }}</label
                    >
                  </div>
                  <div class="dropdown" v-show="accountTypeDropdownOpen">
                    <div v-on:click="setAccountType('1')">
                      {{ t("Demo_label") }}
                    </div>
                    <div v-on:click="setAccountType('2')">
                      {{ t("Real_label") }}
                    </div>
                  </div>
                  <!--                  <div class="errMsg">wrong identifier</div>-->
                </div>
              </div>
              <!-- regulation -->
              <!--<div class="input-wrapper valid">
                <div class="form-group">
                  <div class="input_wrap hide-icon">
                    <select name="regulation">
                      <option value="1" selected>CySEC</option>
                      <option value="2">HSN</option>
                    </select>
                    <label class="floating_labels active">Regulation</label>
                  </div>
                </div>
              </div>-->

              <!-- PhoneNumber -->
              <div
                class="input-wrapper phone"
                :class="[{ invalid: flaggedFields.phone }, inputPhoneStatus]"
              >
                <div class="form-group phone-container">
                  <div class="country_code_container">
                    <span class="plus">+</span>
                    <input
                      name="PhoneCountryCode"
                      class="PhoneCountryCode"
                      type="tel"
                      v-model="regFormPartTwo.phoneCCode"
                      v-on:focus="focusedElem('phone')"
                      v-on:blur="blurredElem('phone')"
                      maxlength="4"
                    />
                  </div>
                  <div class="phoneWrap">
                    <input
                      name="PhoneNumber"
                      class="PhoneNumber"
                      type="tel"
                      :placeholder="t('Form_Phone')"
                      v-model="regFormPartTwo.phoneNumValue"
                      v-on:focus="focusedElem('phone')"
                      v-on:blur="blurredElem('phone')"
                      maxlength="14"
                    />
                    <label
                      class="floating_labels"
                      :class="{ active: regFormPartTwo.phoneNumValue != '' }"
                      >{{ t("Form_Phone") }}</label
                    >
                  </div>
                </div>
                <div class="errMsg">
                  {{ t("Please_insert_valid_phone_number") }}
                </div>
              </div>
              <div class="btnWrap">
                <button class="btn semiBold continue-btn" type="submit">
                  {{ t("Continue_label") }}
                </button>
                <!--                <p class="risk">69.8% of retail CFD accounts lose money</p>-->
              </div>
            </form>
            <!-- /phone form -->
          </div>
          <div class="front login" v-show="this.displayedAuthForm == 'login'">
            <!-- login form -->
            <form
              id="log_in_form"
              v-on:submit.prevent="submitLoginForm"
              data-from-ignore-me
            >
              <div
                class="server_error_msg"
                :class="{ active: this.loginForm.formError }"
              >
                <div class="err_sign"></div>
                <!--                important note: applying click prevent on the paragraph below, because currently the only possible clicking behavior, is a log in redirection link which might appear as part of the error message, and we don't want it to redirect to the platform's login. similar logic is happening at the "onClickLoginRedirectionErrMsg" for the same error message at the registration form with additional redirection-->
                <p v-html="this.loginForm.errorMessage" @click.prevent=""></p>
              </div>

              <!-- FirstName -->
              <div class="input-wrapper">
                <div class="form-group">
                  <div class="input_wrap">
                    <input
                      type="text"
                      name="user_id"
                      :placeholder="t('Email_TP_label')"
                      maxlength="50"
                      v-model="loginForm.userId"
                    />
                    <label class="floating_labels">{{
                      t("Email_TP_label")
                    }}</label>
                  </div>
                  <!--                  <div class="errMsg">wrong identifier</div>-->
                </div>
              </div>

              <!-- password -->
              <div class="input-wrapper password-wrap">
                <div class="form-group">
                  <div class="input_wrap">
                    <input
                      :type="[loginForm.visiblePassword ? 'text' : 'password']"
                      name="Password"
                      :placeholder="t('Forms_Password')"
                      maxlength="15"
                      v-model="loginForm.password"
                    />
                    <label class="floating_labels">{{
                      t("Forms_Password")
                    }}</label>
                    <span
                      class="eye"
                      :class="{
                        active: loginForm.visiblePassword,
                        showEye: loginForm.password.length > 0
                      }"
                      v-on:click="this.togglePasswordVisibilityLogin"
                    ></span>
                  </div>
                  <!--                  <div id="passwordPopup" style="display: none">-->
                  <!--                    <h3>Password must contain:</h3>-->
                  <!--                    <p id="length">A minimum of 6 characters</p>-->
                  <!--                    <p id="letter">At least one lowercase letter (a-z)</p>-->
                  <!--                    <p id="capital">At least one uppercase letter (A-Z)</p>-->
                  <!--                    <p id="number">At least one number (9-0)</p>-->
                  <!--                    <p id="hasNoSpecialCharacters">-->
                  <!--                      Don't use special characters and spaces-->
                  <!--                    </p>-->
                  <!--                    <p id="onlyEnglishCharacters">-->
                  <!--                      Use only English characters-->
                  <!--                    </p>-->
                  <!--                  </div>-->
                  <!--                  <div class="errMsg">Please insert valid password</div>-->
                </div>
              </div>
              <div class="forgot-password-wrapper">
                <a
                  :href="
                    platformUrl.trader_link + 'login-area-new/forgot-password'
                  "
                  >{{ t("Forgot_password_label") }}</a
                >
              </div>

              <div class="btnWrap">
                <button class="btn semiBold login-btn" type="submit">
                  {{ t("Header_Nav_Log_In") }}
                </button>
                <!--                <p class="risk">69.8% of retail CFD accounts lose money</p>-->
              </div>

              <div class="social_signIn">
                <div class="titleWrapper">
                  <span class="decoration"></span>
                  <span>{{ t("Login_with") }}</span>
                  <span class="decoration"></span>
                </div>
                <div class="linkWrap">
                  <a class="fb" @click="signUpWithThirdParty('facebook')"></a>
                  <a class="google" @click="signUpWithThirdParty('google')"></a>
                  <a class="apple" @click="signUpWithThirdParty('apple')"></a>
                </div>
              </div>
              <div class="existing-account">
                <span>{{ t("Dont_have_account") }} </span>
                <span
                  v-on:click="this.switchToRegistrationView"
                  class="login-text"
                  >{{ t("Header_Nav_Sign_Up") }}</span
                >
              </div>
            </form>
            <!-- /login form -->
          </div>
        </div>
      </div>
      <!-- END FORM FLIP -->
    </div>
    <div
      class="membershipEnded"
      v-if="this.isLoggedIn && !this.membershipActive"
    >
      <h2>{{ t("Membership_expired_label") }}</h2>
      <!--      <h2>Hey {{ userFirstName }}, You're Membership is expired!</h2>-->
      <p>
        {{ t("Membership_expired_body") }}
      </p>
      <a class="btn" :href="userLoginLink">{{ t("Congratulations_CTA") }}</a>
    </div>
    <MessageModal v-if="successRegistrationPopup" />
  </div>
</template>

<script>
import MessageModal from "@/components/MessageModal";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import { getElemTopPosition, scrollToForm, isIOS } from "@/utils/general";
import apiRequest from "@/services/apiRequest";

let firebase; //var to hold the firebase package (/respond from initiation) after dynamic importing


export default {
  name: "LoginOrRegister",
  props: ["webinarDatePassed"],
  components: { MessageModal },
  data: function() {
    return {
      status: "registration", //temp,
      currentFocused: "",
      flaggedFields: {
        name: false,
        email: false,
        password: false,
        phone: false
      }, //list of field which will temporarily show invalid icon after submission, even if have not content
      regFormPartOne: {
        name: "",
        email: "",
        password: "",
        terms: "",
        visiblePassword: false,
        formError: false,
        errorMessage: ""
      },
      regFormPartTwo: {
        accountType: "2",
        phoneCCode: "",
        phoneNumValue: "",
        formError: false,
        errorMessage: ""
      },
      loginForm: {
        userId: "",
        password: "",
        formError: false,
        errorMessage: "",
        visiblePassword: false
      },
      countriesInfo: {},
      accountTypeDropdownOpen: false
    };
  },
  computed: {
    ...mapState("loginOrRegister", {
      successRegistrationPopup: state => state.showMessageModal
    }),
    ...mapState([
      "isLoggedIn",
      "registrationStep",
      "displayedAuthForm",
      "membershipActive",
      "userFirstName",
      "accountId",
      "webInfo",
      "platformUrl",
      "userStatusReturned"
    ]),
    ...mapGetters(["t", "traderDict", "userLoginLink", "baseApiUrl"]),
    accountType: function() {
      if (this.regFormPartTwo.accountType == 2) {
        return this.t("Real_label");
      }
      return this.t("Demo_label");
    },
    validName: function() {
      let regex = /^[^0-9!,#$%^&*()]{3,100}$/;
      let field = this.regFormPartOne.name;
      return this.validateField(field, regex);
    },
    inputNameStatus: function() {
      return this.inputClass(this.validName, "name");
    },
    validEmail: function() {
      let regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      let field = this.regFormPartOne.email;
      return this.validateField(field, regex);
    },

    inputEmailStatus: function() {
      return this.inputClass(this.validEmail, "email");
    },
    inputPasswordStatus: function() {
      let passwordStatus;
      if (this.regFormPartOne.password == "") {
        passwordStatus = "";
      } else {
        passwordStatus = this.allPasswordReqsFullfilled();
      }
      return this.inputClass(passwordStatus, "password");
    },
    validCCode: function() {
      let regex = /^[\d]{1,4}$/;
      let field = this.regFormPartTwo.phoneCCode;
      return this.validateField(field, regex);
    },
    validPhoneNumber: function() {
      let regex = /^[\d]{7,14}$/;
      let field = this.regFormPartTwo.phoneNumValue;
      return this.validateField(field, regex);
    },
    inputPhoneStatus: function() {
      return this.inputClass(this.validCCode && this.validPhoneNumber, "phone");
    },

    showPasswordRequirements: function() {
      if (
        this.currentFocused == "password" &&
        !this.allPasswordReqsFullfilled()
      ) {
        return true;
      }
      return false;
    },
    validPasswordLen: function() {
      let field = this.regFormPartOne.password;
      return field.length > 5;
    },
    validPasswordSLetter: function() {
      let regex = /([a-z])/;
      let field = this.regFormPartOne.password;
      return this.validateField(field, regex);
    },
    validPasswordCLetter: function() {
      let regex = /([A-Z])/;
      let field = this.regFormPartOne.password;
      return this.validateField(field, regex);
    },
    validPasswordNumber: function() {
      let regex = /([0-9])/;
      let field = this.regFormPartOne.password;
      return this.validateField(field, regex);
    },
    validPasswordNoSpecial: function() {
      // let regex=/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/;
      let regex = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;
      let field = this.regFormPartOne.password;
      return !this.validateField(field, regex);
    },
    validPasswordOnlyEnglish: function() {
      let regex = /[^A-Za-z0-9]+/;
      let field = this.regFormPartOne.password;
      return !this.validateField(field, regex);
    },
    termsValidationClass: function() {
      let returnVal;
      switch (this.regFormPartOne.terms) {
        case "": //initial case
          returnVal = "";
          break;
        case true:
          returnVal = "valid";
          break;
        case false:
          returnVal = "invalid";
          break;
        default:
          break;
      }
      return returnVal;
    },
    currentPage: function() {
      const path = window.location.href.replace(
        this.webInfo.getFullHostWithProtocol(),
        ""
      );
      let pathUnderPlusURL = new RegExp("^/plus/").test(path); //in case it will be required in additional places turn it to a general function,
      if (pathUnderPlusURL) {
        return path.split("/")[2];
      } else {
        return path.split("/")[1];
      }
    },
    subTitle: function() {
      let subTitle;
      let page = this.currentPage;
      if (["trading-signals", "instruments"].includes(page)) {
        //note: in case login form will have to be displayed under additional tabs at instrument page, an alternative solution will be required
        subTitle = "Signal_sentence";
      }
      if (page === "financial-tv") {
        subTitle = "WebTV_Sentence";
      }
      if (page === "webinars") {
        subTitle = this.webinarDatePassed
          ? "Webinar_Sentence_past"
          : "Webinar_Sentence";
      }
      if (page === "ebooks") {
        subTitle = "ebook_sentence";
      }
      if (page === "news") {
        subTitle = "News_sentence";
      }

      return subTitle;
    },
    isRegStepOne: function() {
      return (
        this.displayedAuthForm == "registration" && this.registrationStep == 1
      );
    }
  },
  created() {
    this.getCountryCodes();
    this.getInfoFromWebsite("traderDictionary");
  },
  methods: {
    ...mapMutations([
      "setUserFirstName",
      "incrementPendingApiCallsCount",
      "decrementPendingApiCallsCount",
      "setLoginStatus"
    ]),
    ...mapActions("loginOrRegister", [
      "registerStep1",
      "registerStep2",
      "loginRequest"
    ]),
    ...mapActions(["getInfoFromWebsite"]),
    ...mapMutations("loginOrRegister", ["setShowMessageModal"]),
    ...mapMutations([
      "setLoginStatus",
      "setRegistrationStep",
      "setdisplayedAuthForm",
      "setAccountId",
      "setMembershipActive"
    ]),
    dynamicallyImportFirebase: function() {
      // 1.in order to solve issue at edge browser
      // 2.importing firebase after facebook/google/apple btn click, is allowing performance improvement in lighthouse speed test
      if(!firebase){
        const promise1 = import("firebase/app");
        const promise2 = import("firebase/auth");
        return Promise.all([promise1, promise2]).then(values => {
          firebase = values[0];
          this.initializeFirebase();
        });
      } else {
        return Promise.resolve();
      }
    },
    initializeFirebase: function() {
      var host = location.host || location.hostname;
      var domain = host.substr(host.lastIndexOf(".") + 1);
      // Your web app's Firebase configuration
      var firebaseConfig = {
        apiKey: "AIzaSyACb257MJbeL5tx5MOgMotyAWLL_oYIWVQ",
        authDomain: "auth.alvexo." + domain, //tradingapp-e4063.firebaseapp.com
        databaseURL: "https://tradingapp-e4063.firebaseio.com",
        projectId: "tradingapp-e4063",
        storageBucket: "tradingapp-e4063.appspot.com",
        messagingSenderId: "520431877223",
        appId: "1:520431877223:web:7f1b35f1164ac9914ce8c2"
      };
      // Initialize Firebase
      firebase.initializeApp(firebaseConfig);
      // eslint-disable-next-line no-unused-vars
      var provider = new firebase.auth.GoogleAuthProvider();
      firebase.auth().languageCode = "en";
    },
    setAccountType: function(type) {
      console.log("type", type);
      this.regFormPartTwo.accountType = type;
      this.accountTypeDropdownOpen = false;
    },
    switchToLoginView: function() {
      this.setdisplayedAuthForm("login");
    },
    switchToRegistrationView: function() {
      this.setdisplayedAuthForm("registration");
    },
    validateField: function(field, regex) {
      if (field == "") {
        return "";
      }
      if (regex.test(field)) {
        return true;
      } else {
        return false;
      }
    },
    inputClass: function(stautsHolder, fieldName) {
      if (stautsHolder === true) {
        // this.flaggedFields = this.flaggedFields.filter((e) => e !== fieldName); //the line that caused infinate loop and broke the system on stage env
        this.flaggedFields[fieldName] = false;
        return "valid";
      } else if (stautsHolder === false && this.currentFocused != fieldName) {
        return "invalid";
      }
      if (this.flaggedFields.fieldName) {
        return "invalid";
      }
      return "";
    },
    focusedElem: function(elem) {
      console.log("elm", elem);
      this.currentFocused = elem;
    },
    blurredElem: function(elem) {
      console.log("this.currentFocused", this.currentFocused);
      if (this.currentFocused == elem) {
        this.currentFocused = "";
        console.log("focused out");
      }
    },
    togglePasswordVisibilityReg: function() {
      this.regFormPartOne.visiblePassword = !this.regFormPartOne
        .visiblePassword;
    },
    togglePasswordVisibilityLogin: function() {
      this.loginForm.visiblePassword = !this.loginForm.visiblePassword;
    },
    allPasswordReqsFullfilled: function() {
      let passwordTests = [
        this.validPasswordLen,
        this.validPasswordSLetter,
        this.validPasswordCLetter,
        this.validPasswordNumber,
        this.validPasswordNoSpecial,
        this.validPasswordOnlyEnglish
      ];
      return !passwordTests.includes(false);
    },
    submitStep1: function() {
      this.removeLoginRedirectionEventListener();
      this.regFormPartOne.errorMessage = "";
      this.regFormPartOne.formError = false;
      let passwordTests = [
        this.validName,
        this.validEmail,
        this.allPasswordReqsFullfilled(),
        this.regFormPartOne.terms
      ];
      let doesAllFieldsValid = !(
        passwordTests.includes(false) || passwordTests.includes("")
      );
      if (doesAllFieldsValid) {
        this.signUpRequest(this.regFormPartOne);
      } else {
        if (this.regFormPartOne.name === "") {
          this.flaggedFields.name = true;
        }
        if (this.regFormPartOne.email === "") {
          this.flaggedFields.email = true;
        }
        if (!this.allPasswordReqsFullfilled()) {
          this.flaggedFields.password = true;
        }
        if (this.regFormPartOne.terms === "") {
          this.regFormPartOne.terms = false;
        }
      }
    },
    async getCountryCodes() {
      let json = await apiRequest.get(this.baseApiUrl("general/country") + "general/country");
      // let {countries, country, dial_code} = json;
      let { countries, dial_code } = json;
      this.countriesInfo = countries;
      this.regFormPartTwo.phoneCCode = dial_code;
    },
    async signUpRequest(formInputs) {
      this.incrementPendingApiCallsCount();
      let payLoadRegister = {
        "inputs[fullName]": formInputs.name,
        "inputs[email]": formInputs.email,
        "inputs[password]": formInputs.password,
        "inputs[page_url]": location.href
      };
      if (formInputs.firebaselogin) {
        payLoadRegister["inputs[firebaselogin]"] = formInputs.firebaselogin;
      }
      let data = await apiRequest.post(
        this.baseApiUrl() + "lead/create-lead",
        payLoadRegister
      );
      if (
        (data.Message != "undefined" && data.succeeded == false) ||
        (data.type && data.type == " err")
      ) {
        //couldn't return the acctual "catched" err obj from the "apiRequest" service
        this.removeLoginRedirectionEventListener();
        let currentFormDataName; //we need to determine the form in which the error will appear, because this function also uses for the 3rd party login at the login form
        if (this.displayedAuthForm == "login") {
          currentFormDataName = "loginForm";
        } else if (this.displayedAuthForm == "registration") {
          currentFormDataName = "regFormPartOne";
        }
        this[currentFormDataName].errorMessage = this.traderDict(data.Message);
        if (
          data.Message === "API_ACCOUNT_ALREADY_EXISTS_PLEASE_LOGIN" &&
          this.displayedAuthForm == "registration"
        ) {
          // this.regFormPartOne.errorMessage = this.traderDict(data.Message).replace(/href=".*\/login-area\/login"/,''); //removes the href from the a tag
          const that = this;
          setTimeout(function() {
            //otherwise that loginErrContainer might not get updated yet with the content
            that.addLoginRedirectionEventListener();
          }, 0);
        }
        this[currentFormDataName].formError = true;
        this.decrementPendingApiCallsCount();
      } else {
        //  succeeded
        if (data.isLogged) {
          this.successfulLoginActions(data);
        } else {
          this.switchToRegistrationView(); //for case of login with apple\facebook\google
          this.decrementPendingApiCallsCount();
          this.setRegistrationStep(2);
          if (window.matchMedia("(max-width: 768px)").matches) {
            scrollToForm();
          }
        }
      }
    },
    submitStep2: function() {
      this.regFormPartTwo.errorMessage = "";
      this.regFormPartTwo.formError = false;
      let passwordTests = [this.validCCode, this.validPhoneNumber];
      let doesAllFieldsValid = !(
        passwordTests.includes(false) || passwordTests.includes("")
      );
      if (doesAllFieldsValid) {
        this.phoneFormRequest();
      } else {
        if (
          this.regFormPartTwo.phoneCCode === "" ||
          this.regFormPartTwo.phoneNumValue === ""
        ) {
          this.flaggedFields.phone = true;
        }
      }
    },
    async phoneFormRequest() {
      this.incrementPendingApiCallsCount();
      let payLoadRegister = {
        "inputs[demolive]": this.regFormPartTwo.accountType,
        "inputs[telephone]":
          this.regFormPartTwo.phoneCCode +
          "-" +
          this.regFormPartTwo.phoneNumValue,
        "inputs[countryID]": this.getCountry(this.regFormPartTwo.phoneCCode)
      };
      let data = await apiRequest.post(
        this.baseApiUrl() + "lead/update-lead",
        payLoadRegister
      );
      console.log(data);
      if (
        (data.Message != "undefined" && data.succeeded == false) ||
        (data.type && data.type == " err")
      ) {
        //couldn't return the acctual "catched" err obj from the "apiRequest" service
        this.regFormPartTwo.errorMessage = this.traderDict(data.Message);
        this.regFormPartTwo.formError = true;
        this.decrementPendingApiCallsCount();
      } else {
        //  succeeded
        if (data.isLogged) {
          /*set cookie*/
          let allUrl = window.location.hostname;
          let host = allUrl.split(".");
          this.$cookies.set(
            "cguid",
            data.Account.FirstName,
            "30d",
            "/",
            "." + host[1] + "." + host[2]
          );

          if(process.env.NODE_ENV !== 'development'){
            window.dataLayer.push({ event: "form-submit-success" });
          }
          //note: at platform, user phone number + code are being push to local storage at this part
          this.setUserFirstName(data.Account.FirstName);
          this.setAccountId(data.Account.AccountId);
          // this.setLoginStatus(true);
          this.setLoginStatus(true);
          this.setMembershipActive(true); //todo: use only in case we are using the app as server rendered app, and when the page must be reloaded in order to close the popup shown after registration - if these condition will change remove this line! its is currently added in order to show logged in app state after registration when popup shown. after popup close, the app will be refreshed and the membership data will be derived from the api service
          // let cookieData = data.Account.TradingAccounts[0]
          // this.setLoginCookies(cookieData['nt_name'], cookieData['nt_Password'], cookieData['nt_demolive'], 7)
          this.decrementPendingApiCallsCount();
          this.setShowMessageModal(true);
        }
      }
    },
    submitLoginForm: function() {
      this.loginForm.formError = false;
      this.loginForm.errorMessage = "";
      if (this.loginForm.password != "" && this.loginForm.userId != "") {
        //these are the only tests that is have seen at the platform login
        this.loginRequest();
      }
      return false;
    },
    async loginRequest() {
      this.incrementPendingApiCallsCount();
      const csrfElem = document.querySelector('meta[name="csrfToken"]');
      const csrfToken = csrfElem ? csrfElem.getAttribute("content") : "";

      let payLoadRegister = {
        "inputs[levusr]": this.loginForm.userId,
        "inputs[levpwd]": this.loginForm.password,
        "inputs[_csrf]": csrfToken
      };
      let data = await apiRequest.post(
        this.baseApiUrl() + "client/login",
        payLoadRegister
      );
      console.log("temp data", data);
      if (
        (data.Message != "undefined" && data.succeeded == false) ||
        (data.type && data.type == " err")
      ) {
        //couldn't return the acctual "catched" err obj from the "apiRequest" service
        this.loginForm.errorMessage = this.traderDict(data.Message);
        this.loginForm.formError = true;
        this.decrementPendingApiCallsCount();
      } else {
        //  succeeded
        if (data.isLogged) {
          this.successfulLoginActions(data);
        }
      }
    },
    successfulLoginActions: function(responseData) {
      /*set cookie*/
      let allUrl = window.location.hostname;
      let host = allUrl.split(".");
      this.$cookies.set(
        "cguid",
        responseData.Account.FirstName,
        "30d",
        "/",
        "." + host[1] + "." + host[2]
      );

      // this.setShowMessageModal(true);
      this.setAccountId(responseData.Account.AccountId);
      this.setUserFirstName(responseData.Account.FirstName);
      // this.setLoginStatus(true);
      // this.changeLoginStatus(true); //not required due to page reload // not function does not exist anymore, and was generally replaced by "setLoginStatus"
      // this.setLoaderDisplay(false); //not required due to page reload
      window.scrollTo(0, 0);
      location.reload();
    },
    generatePass: function() {
      let length = 15,
        charset =
          "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }
      return retVal;
    },
    initiateFirebaseProvider(providerName){
      let provider
      switch (providerName) {
        case "google":
          provider = new firebase.auth.GoogleAuthProvider();
          break;
        case "facebook":
          provider = new firebase.auth.FacebookAuthProvider();
          break;
        case "apple":
          provider = new firebase.auth.OAuthProvider("apple.com");
          break;
      }
      return provider;
    },
    signUpWithThirdParty(providerName){
      this.dynamicallyImportFirebase().then(()=>{ //import firebase only after clicking 3rd party login icon, to improve performance in google spped test
        const provider = this.initiateFirebaseProvider(providerName);
        this.signUpWithFirebase(provider);
      });
    },
    signUpWithFirebase: function(provider) {
      let that = this;
      this.incrementPendingApiCallsCount();
      firebase
        .auth()
        .signInWithPopup(provider)
        .then(function(result) {
          const user = result.user;
          let emailValue = user.email;
          if (
            !user.email &&
            result.additionalUserInfo &&
            result.additionalUserInfo.profile &&
            result.additionalUserInfo.profile.email
          ) {
            //polyfill for cases user.email return empty value
            emailValue = result.additionalUserInfo.profile.email;
          }
          console.log("result", result);
          let params = {
            firebaselogin: user.uid,
            name: user.displayName,
            email: emailValue,
            password: that.generatePass()
          };
          that.signUpRequest(params);
          that.decrementPendingApiCallsCount();
          console.log("params", params);
        })
        .catch(function(error) {
          console.log("error", error);
          // that.regFormPartOne.errorMessage = that.traderDict('login_with_google_signin');
          that.regFormPartOne.formError = true;
          that.decrementPendingApiCallsCount();
        });
    },
    getCountry: function(dialCode) {
      for (var i in this.countriesInfo) {
        if (this.countriesInfo[i].dial_code == dialCode) return i;
      }
      return "GB"; //note: this 'GB' is also the default return value at the platform registration
    },
    onClickLoginRedirectionErrMsg: function(event) {
      event.preventDefault();
      this.switchToLoginView();
    },
    addLoginRedirectionEventListener: function() {
      this.$refs["loginErrContainer"]
        .querySelector("a")
        .addEventListener("click", this.onClickLoginRedirectionErrMsg);
    },
    removeLoginRedirectionEventListener: function() {
      this.$refs["loginErrContainer"].querySelector("a") &&
        this.$refs["loginErrContainer"]
          .querySelector("a")
          .removeEventListener("click", this.onClickLoginRedirectionErrMsg);
    },
    scrollOnInputClick(event) {
      event.preventDefault(); //in order to cancel ios's scrolling on input click
      if (window.matchMedia("(max-width: 768px)").matches) {
        setTimeout(function() {
          //in order to allow passwordPopup appear and "receive dom height" first + set to 50ms in order to let iOS finish its scroll - not great but thats what the product wanted
          const elem = event.target;
          const headerElem = document.querySelector("header");
          let totalScroll = getElemTopPosition(elem) - 64; //"-64" according to Ron's logic to get close to the edge but further then password
          if (!isIOS()) {
            //ios hides header on input focus
            totalScroll -= headerElem.offsetHeight;
          }
          window.scrollTo(document.body.scrollLeft, totalScroll);
        }, 50);
      }
    },
    scrollOnPasswordClick: function(event) {
      event.preventDefault(); //in order to cancel ios's scrolling on input click
      setTimeout(function() {
        //in order to allow passwordPopup appear and "receive dom height" first + set to 50ms in order to let iOS finish its scroll - not great but thats what the product wanted
        let totalScroll;
        const passwordWrapper = document.querySelector(
          ".input-wrapper.password"
        );
        const passwordInput = passwordWrapper.getElementsByTagName("input")[0];
        if (window.matchMedia("(max-width: 768px)").matches) {
          const headerElem = document.querySelector("header");
          totalScroll = getElemTopPosition(passwordInput) - 16; //"-16" is in order to go a bit before the field.offsetHeight
          if (!isIOS()) {
            //ios hides header on input focus
            totalScroll -= headerElem.offsetHeight;
          }
          window.scrollTo(document.body.scrollLeft, totalScroll);
        } else {
          const passwordPopup = document.getElementById("passwordPopup");
          const stickyButtonElem = document.querySelector(
            ".sticky_bottom_wrap"
          );
          const vh = document.documentElement.clientHeight;
          totalScroll =
            getElemTopPosition(passwordInput) -
            vh +
            passwordInput.offsetHeight +
            passwordPopup.offsetHeight +
            stickyButtonElem.offsetHeight +
            12; //"+12" is in order to go a bit after the end
          if (document.documentElement.scrollTop < totalScroll) {
            window.scrollTo(document.body.scrollLeft, totalScroll);
          }
        }
      }, 50);
    }
  }
};
</script>

<style lang="scss">
/*private cases*/
@media only screen and (min-width: 601px) {
  .webinars .form_wrap .sub-title {
    max-width: 560px;
  }
  .ebooks .form_wrap .sub-title {
    max-width: 490px;
  }
}
/*end of private cases*/

.form_wrap {
  padding: 2rem 0 2.5rem;
  text-align: center;
  background-color: #f5f5f5;
  box-shadow: 0px 3px 6px #00000040;
  color: #424242;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    svg {
      .a {
        fill: #424242;
      }
      .b {
        fill: #87b62a;
      }
      .c {
        fill: #8ac33f;
      }
      height: 40px;
    }
    margin-bottom: 24px;
    .alvexo {
      font-size: 33px;
    }
    .plus {
      color: #8bc63f;
      font-size: 24px;
    }
  }
  .sub-title {
    font-size: 18px;
    margin-bottom: 24px;
    max-width: 478px;
    font-weight: normal;
  }
  form {
    width: 100%;
    .input-wrapper {
      position: relative;
      min-height: 70px;
      &:focus-within {
        .input_wrap,
        .phone-container {
          &:not(.hide-icon) {
            &:after {
              background: none;
            }
          }
        }
        .input_wrap input {
          border: 1px solid #1c79be;
        }
        .errMsg {
          display: none;
        }
        label.floating_labels {
          color: #1c79be;
        }
        .phone-container {
          border: 1px solid #1c79be;

          &:focus-within {
            //border-bottom: 2px solid #ff004e;
            border: 1px solid #1c79be;
          }
        }
      }
      &.invalid {
        &.password,
        &.phone {
          /*required due to the fact last-of-type selector matches elements and cant match classes, therefore we can't use last-of-type for "input-wrapper"*/
          &:not(:focus-within) {
            min-height: 86px;
          }
        }
      }
    }
    input {
      width: 100%;
      height: 40px;
      border-radius: 3px;
      padding: 1px 15px 0;
      border: 1px solid #d5d3d3;
      color: #424242;
      outline: none;
      background: transparent;
      font-size: 18px;
      &:focus {
        //padding: 7px 15px 0;
        + {
          .floating_labels {
            opacity: 1;
            transform: translate3d(0, 50%, 0);
            z-index: 0;
            top: -20px;
            background: #f5f5f5;
            font-size: 13px;
          }
        }
      }
    }
    select {
      width: 100%;
      height: 40px;
      border-radius: 3px;
      padding: 0 15px;
      border: 1px solid #d5d3d3;
      color: #424242;
      outline: none;
      background: transparent;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      &::-ms-expand {
        display: none;
      }
    }
    .phone-container {
      width: 100%;
      height: 40px;
      border-radius: 3px;
      padding: 1px 15px 0;
      border: 1px solid #d5d3d3;
      color: #424242;
      outline: none;
      background: transparent;
      position: relative;
      display: flex;
      align-items: center;
      &:hover {
        box-shadow: 0 0 6px #00000029;
      }
      &:focus-within {
        border: 1px solid #1c79be;
      }
      span {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
      }
      input {
        border: none;
        background: transparent;
      }
      input[name="PhoneCountryCode"] {
        width: 100%;
        padding: 0 10px 0 12px;
      }
      input[name="PhoneNumber"] {
        padding: 0 15px 0 0;
      }
    }
    .valid {
      input {
        //&:focus {
        //  padding: 7px 15px 0;
        //}
        //border-bottom: 2px solid #99cd57;

        &.PhoneNumber,
        &.PhoneCountryCode {
          border-bottom: none;
        }
      }
      .phone-container {
        //border-bottom: 2px solid #99cd57;
        &:focus-within {
          //border-bottom: 2px solid #99cd57;
        }
        &:after {
          content: "";
          position: absolute;
          right: 15px;
          width: 26px;
          height: 26px;
          top: 50%;
          transform: translate(0, -50%);
          background: url(../assets/images/components/form/valid_icon.svg)
            center / 100% no-repeat;
        }
      }
      label.floating_labels {
        color: #7a7c7c;
      }
      .input_wrap {
        &:after {
          content: "";
          position: absolute;
          right: 15px;
          width: 26px;
          height: 26px;
          top: 50%;
          transform: translate(0, -50%);
        }
        &:not(.hide-icon) {
          &:after {
            background: url(../assets/images/components/form/valid_icon.svg)
              center / 100% no-repeat;
          }
        }
      }
      //input[name="PhoneNumber"] {
      //  &:focus {
      //    border: 1px solid transparent;
      //  }
      //}
      input[name="PhoneCountryCode"] {
        &:focus {
          border: 1px solid transparent;
        }
      }
    }
    .invalid {
      input {
        //&:focus {
        //  padding: 7px 15px 0;
        //}
        //border-bottom: 2px solid #ff004e;
        border: 1px solid #ff004e;
      }
      .phone-container {
        input {
          border: none;
          background: transparent;
        }
        //border-bottom: 2px solid #ff004e;
        border: 1px solid #ff004e;
        &:focus-within {
          //border-bottom: 2px solid #ff004e;
          border: 1px solid #ff004e;
        }
        &:after {
          content: "";
          position: absolute;
          right: 15px;
          width: 26px;
          height: 26px;
          top: 50%;
          transform: translate(0, -50%);
          background: url(../assets/images/components/form/invalid_icon.svg)
            center / 100% no-repeat;
        }
      }
      label.floating_labels {
        color: #ff004e;
      }
      .errMsg {
        display: block;
        color: #ff004e;
      }
      .input_wrap {
        &:after {
          content: "";
          position: absolute;
          right: 15px;
          width: 26px;
          height: 26px;
          top: 50%;
          transform: translate(0, -50%);
        }
        &:not(.hide-icon) {
          &:after {
            background: url(../assets/images/components/form/invalid_icon.svg)
              center / 100% no-repeat;
          }
        }
      }
    }
    .select2-hidden-accessible {
      width: 100% !important;
      height: 56px !important;
      padding: 0 15px !important;
      border: 1px solid #d5d3d3 !important;
    }
    .select2-container {
      width: 100% !important;
      height: 56px !important;
      outline: none;
    }
    .select2-container--default {
      .select2-selection--single {
        background: #fff;
        border: 1px solid #d5d3d3;
        border-radius: 3px;
        height: 100%;
        border: 1px solid #d5d3d3;
        .select2-selection__rendered {
          position: relative;
          z-index: 1;
          display: flex;
          align-items: center;
          outline: none;
          padding: 0 15px;
          height: 100%;
        }
        .select2-selection__arrow {
          display: flex;
          align-items: center;
          height: 100%;
          b {
            border-color: #424242 transparent transparent transparent;
            margin-left: -15px;
          }
        }
      }
    }
    span.select2-selection.select2-selection--single {
      outline: none;
    }
    .select2-container--default.select2-container--open.select2-container--below {
      .select2-selection--single {
        border: 1px solid #1c79be;
      }
    }
    .select2-container--default.select2-container--open {
      .select2-selection--single {
        .select2-selection__arrow {
          b {
            border-color: transparent transparent #424242 transparent;
          }
        }
      }
    }
    .form-group {
      width: 100%;
      margin-bottom: 0;
      .dropdown {
        position: absolute;
        background: #f5f5f5;
        z-index: 1;
        width: 100%;
        text-align: left;
        border-right: 1px solid #d5d3d3;
        border-bottom: 1px solid #d5d3d3;
        border-left: 1px solid #d5d3d3;
        border-image: initial;
        border-top: none;
        > div {
          height: 40px;
          display: flex;
          align-items: center;
          padding: 0 16px;
          &:hover {
            background: #d5d3d3;
          }
        }
      }
      > .input_wrap {
        position: relative;
      }
      span.eye {
        display: none;
        position: absolute;
        z-index: 1;
        right: 0;
        top: 50%;
        transform: translate(-50%, -50%);
        height: 24px;
        width: 24px;
        background: url(../assets/images/components/form/password_eye_hidden.svg)
          center / cover no-repeat;
        cursor: pointer;
      }
      span.eye.active {
        background: url(../assets/images/components/form/password_eye.svg)
          center / cover no-repeat;
      }
      input {
        &::placeholder {
          color: #7a7c7c;
        }
        &:-ms-input-placeholder {
          color: #7a7c7c;
        }
        &::-webkit-input-placeholder {
          color: #7a7c7c;
        }
        &:focus {
          &::-webkit-input-placeholder {
            color: transparent;
          }
          &:-moz-placeholder {
            color: transparent;
          }
          &::-moz-placeholder {
            color: transparent;
          }
          &:-ms-input-placeholder {
            color: transparent;
          }
        }
        &:-webkit-autofill {
          -webkit-box-shadow: 0 0 0 30px #f5f5f5 inset !important;
          &:hover {
            -webkit-box-shadow: 0 0 0 30px #f5f5f5 inset !important;
          }
          &:focus {
            -webkit-box-shadow: 0 0 0 30px #f5f5f5 inset !important;
          }
          &:active {
            -webkit-box-shadow: 0 0 0 30px #f5f5f5 inset !important;
          }
        }
      }
      span.eye.showEye {
        display: block;
      }
    }
    .accountType {
      input {
        padding: 0 16px;
        font-size: 16px;
      }
    }
    .form-control {
      font-size: 18px;
    }
    .input_wrap {
      &:hover {
        box-shadow: 0 0 6px #00000029;
      }
    }
    .country_code_container {
      width: 20%;
      position: relative;
    }
    .phoneWrap {
      width: 80%;
    }
    .btn {
      font-size: 16px;
      background: #1c79be;
      color: #fff;
      border-radius: 3px;
      width: 100%;
      height: 40px;
      outline: none;
      font-weight: 500;
      &:hover {
        color: #fff;
      }
    }
    button[disabled] {
      background: #d5d3d3;
      color: #7a7c7c;
      cursor: default;
    }
    .checkboxWrap {
      display: flex;
      position: relative;
      margin: -5px 0 16px;
      .input-wrapper {
        position: relative;
        width: 21px;
        height: 21px;
        min-height: auto;
        margin: 1px 8px 0 0;
        &:hover {
          box-shadow: 0 0 6px #00000029;
        }
        input {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 1;
          opacity: 0;
          display: block;
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        label {
          cursor: pointer;
          position: absolute;
          top: 0;
          left: 0;
          z-index: 0;
          width: 100%;
          height: 100%;
          background: transparent;
          border: 1px solid #d5d3d3;
          border-radius: 3px;
          &:after {
            content: "";
            opacity: 0;
            position: absolute;
            z-index: 1;
            width: 13px;
            height: 7px;
            background: transparent;
            bottom: 8px;
            left: 3px;
            border: 2px solid #fff;
            border-top: none;
            border-right: none;
            -webkit-transform: rotate(-45deg);
            transform: rotate(-45deg);
          }
        }
        input[type="checkbox"] {
          &:checked {
            + {
              label {
                background: #1c79be;
                border: 1px solid #1c79be;
                &:after {
                  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=100)";
                  filter: alpha(opacity=100);
                  opacity: 1;
                }
              }
            }
          }
        }
      }
      .input-wrapper.invalid {
        &:before {
          content: "";
          width: 0;
          height: 0;
          border-top: 4px solid transparent;
          border-left: 8px solid #ff0e36;
          border-bottom: 4px solid transparent;
          position: absolute;
          left: -12px;
          top: 5px;
          -moz-animation: checkbox_arrow_bounce 3s infinite;
          -webkit-animation: checkbox_arrow_bounce 3s infinite;
          animation: checkbox_arrow_bounce 3s infinite;
        }
      }
      .checkbox_txt {
        max-width: 89%;
        line-height: 1.3;
        a {
          text-decoration: none;
        }
      }
    }
    label.floating_labels {
      position: absolute;
      z-index: -1;
      opacity: 0;
      top: 18px;
      left: 12px;
      transition: all 400ms;
      text-align: left;
      background: transparent;
      font-size: 16px;
      padding: 0 4px;
      color: #7a7c7c;
    }
    label.floating_labels.active {
      opacity: 1;
      transform: translate3d(0, 50%, 0);
      z-index: 0;
      top: -20px;
      background: #f5f5f5;
      font-size: 13px;
    }
    .server_error {
      display: none;
      position: relative;
      min-height: 50px;
      background: #ebf3f9;
      font-size: 14px;
    }
    .server_error.active {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 0;
    }
    .server_error_msg {
      display: flex;
      position: relative;
    }
    .server_error_msg.active {
      align-items: center;
      margin: 15px 0;
      background: #ebf3f9;
      padding: 12px 0;
      .err_sign {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        left: 10px;
        width: 34px;
        height: 34px;
        background: url(../assets/images/components/form/error_icon.svg) center /
          100% no-repeat;
      }
      p {
        width: 100%;
        font-size: 14px;
        text-align: center;
        padding: 5px 44px;
        a {
          color: #1c79be;
          font-weight: bold;
        }
      }
    }
    .errMsg {
      display: none;
      font-size: 12px;
      margin: 4px 15px 0;
      text-align: left;
    }
    #passwordPopup {
      width: 100%;
      background: #fff;
      color: #424242;
      position: absolute;
      padding: 13px;
      z-index: 1;
      border-radius: 3px;
      border: 1px solid #e5e5e5;
      box-shadow: 0 3px 6px #00000029;
      h3 {
        text-align: left;
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 10px;
      }
      p {
        display: flex;
        align-items: center;
        padding: 7px 0 7px 23px;
        font-size: 14px;
        color: #212939;
        text-align: left;
        &:before {
          position: absolute;
          content: "";
          border: 1px solid #8e8e8e;
          border-radius: 50%;
          width: 12px;
          height: 12px;
          left: 12px;
        }
      }
      p.valid {
        &:before {
          border: none;
          background: url(../assets/images/components/form/valid_icon.svg)
            center no-repeat;
        }
      }
    }
    .social_signIn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 20px;
      .titleWrapper {
        display: flex;
        color: #7a7c7c;
        font-size: 16px;
        text-align: center;
        position: relative;
        width: 100%;
        span {
          position: relative;
          padding: 0 4px;
          width: 100%;
          color: #7a7c7c;
          white-space: nowrap;
          &.decoration {
            top: 10px;
            border-top: 1px solid #d5d3d3;
          }
        }
      }
      .linkWrap {
        display: flex;
        justify-content: space-between;
        width: 180px;
        margin-top: 20px;
        a {
          width: 48px;
          height: 48px;
          border: 1px solid #d5d3d3;
          border-radius: 50%;
          background: #fff;
          background-position: center;
          background-repeat: no-repeat;
        }
        a.fb {
          background-image: url(../assets/images/components/form/fb_icon.svg);
          &:hover {
            background-image: url(../assets/images/components/form/fb_hover_icon.svg);
          }
        }
        a.google {
          background-image: url(../assets/images/components/form/google_icon.svg);
          &:hover {
            background-image: url(../assets/images/components/form/google_hover_icon.svg);
          }
        }
        a.apple {
          background-image: url(../assets/images/components/form/apple_icon.svg);
          &:hover {
            background-image: url(../assets/images/components/form/apple_hover_icon.svg);
          }
        }
      }
    }
  }
}

.select2-dropdown {
  border: 1px solid #1c79be;
}
.select2-results__option {
  padding: 11px 15px;
}
.select2-container--default {
  .select2-results__option[aria-selected="true"] {
    background-color: transparent;
  }
  .select2-results__option--highlighted[aria-selected] {
    background-color: #ebf3f9;
    color: #424242;
    &:last-child {
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }
}
form[novalidate] {
  input {
    &:focus {
      + {
        .floating_labels {
          color: #7a7c7c;
        }
      }
    }
  }
  label.floating_labels {
    color: #7a7c7c;
  }
}
.form_wrap.regFront-err {
  .sub-title {
    margin-bottom: 0;
  }
}
.input-wrapper {
  .select2-selection__arrow {
    position: absolute;
    top: 1px;
    right: 1px;
    width: 20px;
    display: flex;
    align-items: center;
    height: 100%;
    b {
      border-style: solid;
      border-width: 5px 4px 0 4px;
      height: 0;
      left: 50%;
      margin-top: -2px;
      position: absolute;
      top: 50%;
      width: 0;
      border-color: #424242 transparent transparent transparent;
      margin-left: -15px;
    }
  }
  .open {
    .select2-selection__arrow {
      b {
        border-width: 0 4px 5px 4px;
        border-color: transparent transparent #424242 transparent;
      }
    }
  }
  .accountTypeField {
    z-index: 1;
    position: relative;
  }
}
.btnWrap {
  .risk {
    margin-top: 12px;
  }
}
.top-section {
  .asset_logo_big {
    width: 104px;
    height: 70px;
    margin: 230px 0 0 183px;
    img {
      width: 96px;
    }
  }
}
.flipcard {
  position: relative;
  width: 100%;
  height: 100%;
  perspective: 500px;
  .front {
    position: relative;
    width: 100%;
    height: 100%;
    transition: all 0.7s ease-in;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    z-index: 1;
  }
  .back {
    //position: absolute;
    //top: 0;
    position: relative;
    width: 100%;
    height: 100%;
    transition: all 0.7s ease-in;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }
}
//.flipcard.v.flip {
//  .front {
//    transform: rotateX(180deg);
//  }
//}
//.flipcard.v {
//  .back {
//    transform: rotateX(-180deg);
//  }
//}
//.flipcard.h.flip {
//  .front {
//    transform: rotateY(180deg);
//  }
//  .back {
//    transform: rotateY(0deg);
//  }
//}
//.flipcard.h {
//  .back {
//    transform: rotateY(-180deg);
//  }
//}
.form_wrap.secondary-form {
  .title {
    margin-bottom: 1.5rem;
    margin-top: 10px;
  }
}
.form_wrap.login-form {
  .title {
    margin-bottom: 22px;
    margin-top: 20px;
  }
}
.card-container {
  width: 328px;
  &:not(.regStepOne) {
    transition: all 1.5s ease;
  }
}

//.secondary-form {
//  .card-container {
//    height: 198px;
//  }
//}
//.regBack-err.secondary-form {
//  .card-container {
//    height: 273px;
//  }
//}
//#passwordPopup {
//  display: none;
//}
//#passwordPopup.showReqs {
//  display: block;
//}
.checkbox_txt {
  font-size: 14px;
  text-align: left;
}
.existing-account {
  font-size: 16px;
  font-weight: 500;
}
.social_signIn {
  margin-bottom: 23px;
}
.login-text {
  color: #1c79be;
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.login-form {
  //.card-container {
  //  height: 396px;
  //}
  form#log_in_form {
    .input-wrapper.password-wrap {
      min-height: unset !important;
      margin-bottom: 16px;
    }
  }
  form {
    .social_signIn {
      p {
        &:before {
          width: 112px;
        }
        &:after {
          width: 112px;
        }
      }
    }
  }
}
//.login-form.login-err {
//  .card-container {
//    height: 450px;
//  }
//}
.forgot-password-wrapper {
  text-display: none;
  color: #1c79be;
  font-size: 12px;
  text-align: right;
  margin-bottom: 20px;
}
.flipcard.flip {
  .front {
    form {
      label.floating_labels {
        display: none;
      }
    }
  }
}
#alvexoPlusForm .membershipEnded {
  //added "alvexoPlusForm" dependency only for increasing the priority of the selector comparing to bootstrap
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f5f5f5;
  box-shadow: 0px 3px 6px #00000040;
  padding: 2.5rem 4rem;
  h2 {
    font-size: 1.5rem;
    margin-bottom: 1.375rem;
    text-align: center;
  }
  p {
    font-size: 1rem;
    max-width: 380px;
    margin-bottom: 1.875rem;
    text-align: center;
  }
  button {
    background-color: #1c79be;
    width: 330px;
    height: 40px;
    border-radius: 3px;
    color: #f1f1f1;
    font-weight: 500;
    outline: none;
    text-transform: uppercase;
  }
  a.btn {
    background-color: #1c79be;
    width: 330px;
    height: 40px;
    border-radius: 3px;
    color: #f1f1f1;
    font-weight: 500;
    outline: none;
    text-transform: uppercase;

    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      color: #f1f1f1;
    }
  }
}

.ar {
  form {
    .form-group span.eye {
      left: 24px;
      right: auto;
    }
    label.floating_labels {
      left: auto;
      right: 12px;
    }

    .valid .input_wrap:not(.hide-icon):after,
    .invalid .input_wrap:not(.hide-icon):after {
      left: 15px;
      right: auto;
    }

    .errMsg {
      text-align: right;
    }

    .checkboxWrap .input-wrapper {
      margin-right: 0;
      margin-left: 8px;
      &.invalid:before {
        border-left: 0;
        border-right: 8px solid #ff0e36;
        -webkit-animation: checkbox_arrow_bounce_rtl 3s infinite;
        animation: checkbox_arrow_bounce_rtl 3s infinite;
        left: auto;
        right: -12px;
      }
    }

    #passwordPopup {
      h3 {
        text-align: right;
      }
      p {
        padding: 7px 23px 7px 0;
        &:before {
          left: inherit;
          right: 12px;
        }
      }
    }
  }
  .forgot-password-wrapper {
    text-align: left;
  }
  .login-form form .social_signIn p {
    &:after,
    &:before {
      width: 90px;
    }
  }

  .checkbox_txt {
    text-align: right;
  }

  .input-wrapper .select2-selection__arrow {
    right: auto;
    left: 1px;

    b {
      margin-left: auto;
      margin-right: -15px;
      left: auto;
      right: 50%;
    }
  }

  .input-wrapper.phone {
    direction: ltr;
    .phone-container input[name="PhoneNumber"] {
      padding: 0 0 0 15px;
      direction: rtl;
    }
  }
  .input-wrapper.phone {
    &.invalid,
    &.valid {
      .phoneWrap {
        padding: 0 26px 0 15px;
      }
    }
  }
}

@-webkit-keyframes checkbox_arrow_bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  40% {
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px);
  }
  60% {
    -webkit-transform: translateX(-5px);
    transform: translateX(-5px);
  }
}
@keyframes checkbox_arrow_bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  40% {
    -moz-transform: translateX(-10px);
    -ms-transform: translateX(-10px);
    -webkit-transform: translateX(-10px);
    transform: translateX(-10px);
  }
  60% {
    -moz-transform: translateX(-5px);
    -ms-transform: translateX(-5px);
    -webkit-transform: translateX(-5px);
    transform: translateX(-5px);
  }
}

@-webkit-keyframes checkbox_arrow_bounce_rtl {
  0%,
  20%,
  50%,
  80%,
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  40% {
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
  }
  60% {
    -webkit-transform: translateX(5px);
    transform: translateX(5px);
  }
}
@keyframes checkbox_arrow_bounce_rtl {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateX(0);
    -ms-transform: translateX(0);
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
  40% {
    -moz-transform: translateX(10px);
    -ms-transform: translateX(10px);
    -webkit-transform: translateX(10px);
    transform: translateX(10px);
  }
  60% {
    -moz-transform: translateX(5px);
    -ms-transform: translateX(5px);
    -webkit-transform: translateX(5px);
    transform: translateX(5px);
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS */
  form .invalid input,
  form .invalid .phone-container {
    border: 1px solid #ff004e;
  }
}
@supports (-ms-accelerator: true) {
  /* Edge 12+ CSS */
  form .invalid input,
  form .invalid .phone-container {
    border: 1px solid #ff004e;
  }
}
@supports (-ms-ime-align: auto) {
  /* Edge 16+ CSS */
  form .invalid input,
  form .invalid .phone-container {
    border: 1px solid #ff004e;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS */
  form .valid input:focus:not([name="PhoneNumber"]) {
    border: 1px solid #d5d3d3;
  }
}
@supports (-ms-accelerator: true) {
  /* Edge 12+ CSS */
  form .valid input:focus:not([name="PhoneNumber"]) {
    border: 1px solid #d5d3d3;
  }
}
@supports (-ms-ime-align: auto) {
  /* Edge 16+ CSS */
  form .valid input:focus:not([name="PhoneNumber"]) {
    border: 1px solid #d5d3d3;
  }
}
@media only screen and (max-width: 768px) {
  .form_wrap {
    margin-bottom: 40px;
  }
}
@media only screen and (max-width: 600px) {
  /*.form_desktop_wrap{*/
  /*  margin-bottom: 40px;*/
  /*}*/

  .card-container {
    width: calc(100% - 32px);
  }

  //.secondary-form .card-container[data-v-191d246f] {
  //  height: 214px;
  //}

  //.login-form.login-err .card-container[data-v-191d246f] {
  //  height: 470px;
  //}

  //.regBack-err.secondary-form .card-container[data-v-191d246f] {
  //  height: 289px;
  //}

  .form_wrap {
    padding: 18px 0px;
  }

  /*.form_wrap .title {*/
  /*  margin-bottom: 16px;*/
  /*}*/

  .form_wrap .sub-title {
    font-size: 16px;
    width: 100%;
    max-width: 328px;
  }

  br.desktop {
    display: none;
  }

  form input {
    font-size: 16px;
  }

  form input,
  form select,
  form .phone-container {
    height: 48px;
  }

  form .input-wrapper {
    min-height: 72px;
  }

  form .btn {
    height: 48px;
  }

  form .checkboxWrap {
    margin-top: 0;
  }

  .form_wrap.secondary-form .title {
    margin-top: 0px;
    margin-bottom: 0.75rem;
  }

  #alvexoPlusForm .membershipEnded {
    //added "alvexoPlusForm" dependency only for increasing the priority of the selector comparing to bootstrap
    padding: 1.5rem 1rem 2.5rem;

    h2 {
      margin-bottom: 1.5rem;
    }
    p {
      max-width: 100%;
      margin-bottom: 2rem;
    }
    a.btn {
      max-width: 100%;
      height: 48px;
    }
  }

  form .social_signIn p:before,
  form .social_signIn p:after {
    width: calc(50% - 96px);
  }
  .login-form form .social_signIn p:before,
  .login-form form .social_signIn p:after {
    width: calc(50% - 50px);
  }
}
</style>
